// extracted by mini-css-extract-plugin
export default {"items":"CheckboxGroup_items__LfEgm","checkBox":"CheckboxGroup_checkBox__BLC+-"};